var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { ButtonPrimary, Dropdown, IconLoading, ContentBox, H4 } from '@by-miles/bymiles-styles';
import { DataLayer } from '@by-miles/data-layer';
import { RenewalMonthStyle } from './RenewalMonthStyle';
import { DynamicTitle } from '../DynamicTitle';
import { eventSection } from '../../utils/event';
var mobileUserAgentRegex = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i;
var months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
var renewalMonths = [];
months.forEach(function (month) {
    renewalMonths.push({ label: month, value: month });
});
export var RenewalMonth = function (renewalMonthProps) {
    var _a = useState(false), RenewalError = _a[0], setRenewalError = _a[1];
    var fetching = renewalMonthProps.fetching, renewal_month = renewalMonthProps.renewal_month, updateDataState = renewalMonthProps.updateDataState, handleQuickQuoteSubmission = renewalMonthProps.handleQuickQuoteSubmission, isQQPage = renewalMonthProps.isQQPage;
    useEffect(function () {
        DataLayer.customEvent({
            eventName: 'renewal month',
            eventType: 'virtual page view',
            section: eventSection(isQQPage),
        });
    }, []);
    var handleMonthSelected = function (value) {
        if (RenewalError) {
            setRenewalError(false);
        }
        updateDataState({ stateName: 'renewal_month', value: value });
    };
    var handleRenewalConfirmed = function () {
        if (!renewal_month) {
            setRenewalError(true);
            return false;
        }
        else {
            if (RenewalError) {
                setRenewalError(false);
            }
            handleQuickQuoteSubmission();
            DataLayer.customEvent({
                eventName: 'submit renewal month',
                eventType: 'button click',
                section: eventSection(isQQPage),
            });
        }
    };
    return (_jsxs(RenewalMonthStyle, __assign({ isQQPage: isQQPage }, { children: [_jsx("div", __assign({ className: "title-wrapper" }, { children: _jsx(DynamicTitle, { className: "enter-details-title", isQQPage: isQQPage, title: _jsx("span", { children: "Tell us a little about yourself." }) }) })), _jsx(ContentBox, __assign({ isQQPage: isQQPage, className: "content-box" }, { children: _jsx(_Fragment, { children: fetching ? (_jsx(IconLoading, {})) : (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "widget-box-title padding" }, { children: _jsx(H4, { children: "When does your car insurance renew?" }) })), _jsx("div", __assign({ className: "dropdown ".concat(RenewalError ? 'error' : '') }, { children: _jsx(Dropdown, { handleDropdownChange: function (option) { return handleMonthSelected(option.value); }, options: renewalMonths, placeholder: "Select", isMobile: mobileUserAgentRegex.test(navigator.userAgent), preFilled: renewal_month }) })), _jsx("div", __assign({ className: "button-wrapper" }, { children: _jsx(ButtonPrimary, { iconRight: "IconCaretRight", label: "continue", onClick: function () { return handleRenewalConfirmed(); } }) }))] })) }) }))] })));
};
